
// A utility function that returns "5 seconds ago", "10 minutes ago", etc.
export function formatTimeAgo(pastDate, nowDate) {
    const secondsElapsed = Math.floor((nowDate - pastDate) / 1000);

    if (secondsElapsed < 5) {
        return 'a few seconds ago';

    } else if (secondsElapsed < 60) {
        return `${secondsElapsed} second${secondsElapsed === 1 ? '' : 's'} ago`;
    }

    const minutesElapsed = Math.floor(secondsElapsed / 60);
    if (minutesElapsed < 60) {
        return `${minutesElapsed} minute${minutesElapsed === 1 ? '' : 's'} ago`;
    }

    const hoursElapsed = Math.floor(minutesElapsed / 60);
    if (hoursElapsed < 24) {
        return `${hoursElapsed} hour${hoursElapsed === 1 ? '' : 's'} ago`;
    }

    const daysElapsed = Math.floor(hoursElapsed / 24);
    if (daysElapsed < 7) {
        return `${daysElapsed} day${daysElapsed === 1 ? '' : 's'} ago`;
    }

    // For older data, fallback to a standard date/time
    return pastDate.toLocaleString();
}